import { Box } from "@mui/material";
import React from "react";
import UserInfoBox from "./UserInfoBox";
import Achivments from "./Achivments";
import SubLinks from "./SubLinks";

export default function ClubTab() {
  return (
    <Box
      sx={{
        // border: "1px solid gray",
        zIndex: "-1",
        height: "100%",
        marginBottom: "16px",
        paddingX: "8px",
        paddingBottom: "100px",
      }}
    >
      <UserInfoBox />
      <Achivments />
      <SubLinks />
    </Box>
  );
}
